import React from 'react';
import { ProviderMatchBoardCertification } from '@kyruus/types';

import { ExpertiseEntryContainer } from './styles';
import { insertBetweenItems } from '../../lib/utils';

interface BoardCertificationEntryProps {
  board_certification: ProviderMatchBoardCertification;
}

const BoardCertificationEntry = ({
  board_certification
}: BoardCertificationEntryProps): React.ReactElement => {
  const { specialty_name, board_name, year_certified } = board_certification;
  const specialtyNameMarkup = specialty_name ? (
    <span itemProp="about">{`${specialty_name}: `}</span>
  ) : null;
  const boardNameMarkup = board_name ? (
    <span itemProp="recognizedBy" key="recognizedBy">
      {board_name}
    </span>
  ) : null;
  const yearCertifiedMarkup = year_certified ? (
    <span itemProp="dateCreated" key="dateCreated">
      {year_certified}
    </span>
  ) : null;

  return (
    <ExpertiseEntryContainer
      itemProp="hasCredential"
      itemScope={true}
      itemType="https://schema.org/EducationalOccupationalCredential"
    >
      {specialtyNameMarkup}
      {insertBetweenItems(
        [boardNameMarkup, yearCertifiedMarkup].filter(Boolean),
        ', '
      )}
    </ExpertiseEntryContainer>
  );
};

export default BoardCertificationEntry;
